import { useState, useEffect } from "react";
import Footer from "../components/Footer";

type Props = {};

function Connect({ }: Props) {
    const [config, setConfig] = useState<{ API_URL?: string }>({});

    useEffect(() => {
        fetch("/config.json")
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error loading config.json: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => setConfig(data))
            .catch((error) => console.error("Error loading config:", error));
    }, []);

    return (
        <div className="flex bg-black w-screen h-fit flex flex-col items-center">
            {/* Header */}
            <div className="flex flex-col mt-28 items-center">
                <span className="text-white font-bold text-3xl md:text-4xl xl:text-5xl">
                    Let's connect
                </span>
                <span className="text-white font-regular text-center xl:text-start text-lg xl:text-xl mt-3 xl:mt-8 mb-6">
                    Learn about our common measurement approach or product features.
                </span>
            </div>

            {/* Embedded Microsoft Form */}
            <div className="w-11/12 max-w-4xl bg-white shadow-lg rounded-lg p-6 my-12">
                <iframe
                    width="100%"
                    height="600px"
                    src="https://forms.office.com/r/XsfVfWCV6c?embed=true"
                    frameBorder="0"
                    marginWidth={0}
                    marginHeight={0}
                    style={{
                        border: "none",
                        width: "100%",
                        height: "600px",
                        maxWidth: "100%",
                        maxHeight: "100vh",
                    }}
                    allowFullScreen
                ></iframe>
            </div>

            {/* Footer */}
            <div className="w-11/12 my-7 self-center">
                <Footer />
            </div>
        </div>
    );
}

export default Connect;
